// extracted by mini-css-extract-plugin
export var body = "_ku-0";
export var sectionHeader = "_ku-4";
export var shortcutColumns = "_ku-2";
export var shortcutList = "_ku-1";
export var shortcutSection = "_ku-3";